<template>
  <div class="h-dialogContainer">
    <div class='dp-left-width'>
      <!--<ServerDetailLeft :detailShow="detailShow" :detailInfo="detailInfo" :buttonShow="deployFlag"></ServerDetailLeft>-->
      <ServerDetailLeft :detailShowList="detailShowList" :showAll="false" :detailInfo="detailInfo"></ServerDetailLeft>
    </div>
    <div class='dp-right-width'>
      <ejs-tab ref='deployedTab' heightAdjustMode='heightAdjustMode' cssClass='tabsClass'>
        <div class="e-tab-header h-subscriber-subTabs-header">
          <div v-for="item of headers" :key="item.key">{{item.text}}</div>
        </div>
        <div class="e-content h-subscriber-subTabs-content">
          <div id='deployed'>
            <ejs-treegrid :dataSource="data" :treeColumnIndex='index' :allowSorting='true'  childMapping='child' :height='500'>
              <e-columns>
                <e-column field='name' :headerText='$t("Alarm.neName")' textAlign='Center' width=120 clipMode="EllipsisWithTooltip"></e-column>
                <e-column field='status' :headerText='$t("DeployManagement.runStatus")' textAlign='Left' width=80></e-column>
              </e-columns>
            </ejs-treegrid>
          </div>
        </div>
      </ejs-tab>
    </div>
  </div>
</template>

<script>
import ServerDetailLeft from '../ServerDetailLeft';

export default {
  name: 'DeployedDetailDialog',
  components: {
    ServerDetailLeft
  },
  data() {
    return {
      headers: [
        { text: this.$t('DeployManagement.deployedTab'), iconCss: 'tabsClass', key: 'deployed' }
      ],
      index: 0,
      deployFlag: false,
      data: [
      //   {
      //   serviceName: 'MCS',
      //   productType: 'MCS',
      //   runState: 1,
      //   currentVersion: 'V3.5.0.001',
      //   createTime: 1588830235000,
      //   child: [
      //     { serviceName: 'ASD', productType: 'S_CMS', createTime: 1588830235000, runState: 0 },
      //     { serviceName: 'ACD', productType: 'B_DMS', createTime: 1588830235000, runState: 1 },
      //     { serviceName: 'AED', productType: 'E_EMS', createTime: 1588830235000, runState: 2 }
      //   ]
      // }
      ],
      detailShowList: [
        { name: 'description', value: 'test'},
        { name: 'deliverType', value: '222222'},
        { name: 'createTime', value: '2020-05-23 10:00:10'},
        { name: 'pkgVersion', value: 'tetst'},
      ],
      detailInfo: {
        description: '',
        serviceName: ''
      },
      runstateMap: { // 0-2 DP运行状态  ---待补充5g运行状态
        0: this.$t('DeployManagement.unDeploy'),
        1: this.$t('DeployManagement.unRun'),
        2: this.$t('DeployManagement.runing'),
        20:this.$t('DeployManagement.unDeploy'),
        21: this.$t('DeployManagement.unRun'),
        22: this.$t('DeployManagement.runing'),
        100: this.$t('DeployManagement.connected'), // old网元的运行状态
      },
   };
  },
  methods: {
    queryDPDetailInfo(param) {
      // dp查询已部署服务信息
      console.log('dp查询已部署服务信息', param);
      if (param) {
        this.detailShowList = [
          { name: this.$t('DeployManagement.neName'), value: param.name},
          { name: this.$t('DeployManagement.description'), value: param.description},
          { name: this.$t('DeployManagement.deliverTypeStr'), value: param.deliverTypeStr},
          { name: this.$t('DeployManagement.createTime'), value: new Date(param.createTime).Format('yyyy-MM-dd HH:mm:ss')},
          { name: this.$t('DeployManagement.pkgVersion'), value: param.pkgVersion},
        ];
        this.detailInfo.serviceName = param.serviceName;
      }
      //向后台查询数据-----后台设置运行状态
      this.$axios.post('/lte/ems/deployed/queryDeployedState',{neid: param.neid}).then((res)=>{
        this.data = [];
        if(res.data.resultVal != null) {
          param.status = this.runstateMap[res.data.resultVal];
        }
        this.data.push(param);
      });

    }
  }
};
</script>

<style scoped>

  .h-dialogContainer{
    height:100%;width:100%;
  }
</style>
